import React from 'react';

export default class Timer extends React.Component {

  static defaultProps = {
    started: false,
    time: 60,
  }

  constructor(props) {
    super(props);
    this.started = props.started;
    this.startTime = props.started ? performance.now() : null;
    if (props.started) this.tick();
  }

  componentDidMount() {
    const el = document.createElement('span');
    this.refs.wrapper.appendChild(el);
    this.innerElement = el;
    el.innerHTML = this.props.time;
  }

  componentWillUnmount() {
    this.started = false;
  }

  shouldComponentUpdate(nextProps) {
    if (this.started !== nextProps.started) {
      this.started = nextProps.started;

      if (nextProps.started) {
        this.startTime = performance.now();
        this.tick();
      }
    }

    return false;
  }

  tick = () => {
    const t = performance.now(),
          dt = t - this.startTime;

    let secondsLeft = this.props.time - dt / 1000.0;
    if (secondsLeft < 0) secondsLeft = 0;

    this.innerElement.innerHTML = Math.round(secondsLeft);

    if (secondsLeft === 0) {
      this.props.onEnd();
      this.started = false;
    }

    if (this.started) requestAnimationFrame(this.tick);
  }

  render() {
    return <div ref="wrapper" className={this.props.className} />;
  }
}




// WEBPACK FOOTER //
// ./src/screens/Timer.js